import MockAdapter from 'axios-mock-adapter'

import {saveScenario, sleepResponse, uuidRegEx} from './utils'

import {mockStore} from '@settings/__mock__/mockStore'

export const enableAssetConfigEndpoints = (mock: MockAdapter) => {
  mock
    .onGet(new RegExp(`asset-config/kms-data/plant/${uuidRegEx}/upm-type/Department`))
    .reply(() => {
      const scenario = mockStore.scenario()
      const {
        burglengenfeld: {kilnConfig}
      } = scenario
      return sleepResponse([200, kilnConfig])
    })

  mock
    .onPut(new RegExp(`asset-config/kms-data/plant/${uuidRegEx}/upm-type/Department`))
    .reply((config) => {
      const scenario = mockStore.scenario()
      const {
        burglengenfeld: {kilnConfig: oldKilnConfig}
      } = scenario

      const payload = JSON.parse(config.data as string)

      const newKilnConfig = {...oldKilnConfig, payload}

      scenario.burglengenfeld.kilnConfig = newKilnConfig
      saveScenario(scenario)

      return sleepResponse([200, newKilnConfig])
    })
}
